import type React from "react";
import LocalizedStrings from "react-localization";

import { type EnumsStrings, enumsEn, enumsEs } from "./enums";
import { type MobileStrings, mobileStringsEn, mobileStringsEs } from "./mobile";
import { type PortalStrings, portalStringsEn, portalStringsEs } from "./portal";
import { type SharedStrings, sharedStringsEn, sharedStringsEs } from "./shared";
import { type TasksStrings, tasksStringsEn, tasksStringsEs } from "./tasks";
import { type UiComponents, UiComponentsEn, UiComponentsEs } from "./ui-components";

interface RemiStrings {
  portal: PortalStrings;
  tasks: TasksStrings;
  ui_components: UiComponents;
  enums: EnumsStrings;
  mobile: MobileStrings;
  shared: SharedStrings;
}

export const strings = new LocalizedStrings<RemiStrings>({
  en: {
    portal: portalStringsEn,
    tasks: tasksStringsEn,
    ui_components: UiComponentsEn,
    enums: enumsEn,
    mobile: mobileStringsEn,
    shared: sharedStringsEn,
  },
  es: {
    portal: portalStringsEs,
    tasks: tasksStringsEs,
    ui_components: UiComponentsEs,
    enums: enumsEs,
    mobile: mobileStringsEs,
    shared: sharedStringsEs,
  },
});

// wrapper for react-localization's formatString that returns a string
export const formatString = (
  template: string,
  ...params: (string | number | Record<string, string | number>)[]
): string => {
  return strings.formatString(template, ...params).toString();
};

// wrapper for react-localization's formatString that returns an array of strings and components
export const formatStringWithComponents = (
  template: string,
  ...params: (string | number | Record<string, string | number | React.JSX.Element> | React.JSX.Element)[]
): (string | number | React.JSX.Element)[] => {
  const result = strings.formatString(template, ...params);
  return Array.isArray(result) ? result : [result];
};
